// extracted by mini-css-extract-plugin
module.exports = {"root":"Actions_root__3YOId","action":"Actions_action__1GcG1"};